import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";

export type HelpNavSection = {
  section: string;
  articles: { slug: string; title: string; summary: string; audience: "all" | "admin" }[];
};

export type HelpArticle = {
  slug: string;
  title: string;
  section: string;
  audience: "all" | "admin";
  summary: string;
  body: string;
  prev: { slug: string; title: string } | null;
  next: { slug: string; title: string } | null;
};

export function useHelpNav() {
  return useQuery<{ sections: HelpNavSection[] }>({
    queryKey: ["afell", "help"],
    queryFn: () => apiRequest("/afell/help/"),
  });
}

export function useHelpDoc(slug: string | undefined) {
  return useQuery<HelpArticle>({
    queryKey: ["afell", "help", slug],
    queryFn: () => apiRequest(`/afell/help/${slug}/`),
    enabled: Boolean(slug),
  });
}
